export interface InputText {
  name: string;
  register?: any;
  type: string;
  label: string;
  icon?: string;
}

export interface LoginDev {
  username: string;
  password: string;
}

export interface IProject {
  id: string;
  code: string;
  cover: string;
  name: string;
  estimate_built_at: string;
  total_units: number;
  total_available_units: number;
}

export interface LandlordInfo {
  id: string;
  name: string;
  email: string;
  phone: string;
  avatar: string;
  credit_score: number | null;
  first_name: string;
  last_name: string;
  source: string;
  prebooking_date: string;
  kyc_info: {
    created_at: string;
    id: string;
    status: string;
    updated_at: string;
  };
  can_assign_unit: boolean;
}

export enum KycStatus {
  CREATED = "created", // Initial status when KYC is created
  IN_PROGRESS = "in_progress", // Customer is filling out the form
  IN_REVIEW = "in_review", // Customer finished filling out the form and is waiting for review by snap or admin
  NEED_CUSTOMER_REVIEW = "need_customer_review", // review by customer after is_review status
  COMPLETED = "completed", // completed by review by snap or admin
  DISABLED = "disabled", // KYC is disabled, no longer valid
  PARTIALLY_COMPLETED = "partially_completed"
}

export interface IBookedUser {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  credit_score: number | null;
  source: string;
  kyc_info: {
    id: string;
    status: string;
    created_at: string;
    updated_at: string;
  };
  can_assign_unit: boolean;
}
